import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useRef, useEffect } from 'react';
import Select from 'syf-component-library/ui/atoms/Select/Select';
import { ControlWrapper } from './control.styles';
function getOption(value, options) {
    return options.find(x => x.value === value);
}
const DropdownControl = (props) => {
    const [options] = useState(() => props.inputMetadata.value.map(val => ({ label: val.DisplayLabel, value: val.SubmitValue })));
    const [value, setValue] = useState(getOption(props.value, options));
    const [isrequired] = useState(props.inputMetadata.required === 'true');
    const [optionalText] = useState(isrequired ? "" : " (optional)");
    const selectRef = useRef(null);
    useEffect(() => {
        if (props.shouldFocus && (selectRef === null || selectRef === void 0 ? void 0 : selectRef.current)) {
            selectRef.current.focus();
        }
    });
    const onChange = (option) => {
        setValue(option);
        props.onChange({
            id: props.inputMetadata.id,
            isvalid: !!(isrequired && option.value) || !isrequired,
            value: option.value,
        });
    };
    const htmlProps = {
        'aria-label': props.inputMetadata.labeltext,
    };
    return (React.createElement(ControlWrapper, { hasError: !!props.error },
        React.createElement(Select, Object.assign({ name: props.inputMetadata.id, id: `Alme-Overlay-Form-${props.inputMetadata.id}`, onChange: onChange, placeholder: props.inputMetadata.labeltext + `${optionalText}`, options: options, defaultOption: value, required: isrequired, rightIconOpen: React.createElement(FontAwesomeIcon, { id: `${props.inputMetadata.id}-trigger-chevron-up-icon`, icon: ['far', 'chevron-up'] }), rightIconClosed: React.createElement(FontAwesomeIcon, { id: `${props.inputMetadata.id}-trigger-chevron-down-icon`, icon: ['far', 'chevron-down'] }), error: props.error }, htmlProps, { selectInputRef: selectRef }))));
};
export default DropdownControl;
